/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_D3dInputs */

const en_mk_sol_startup_d3d = /** @type {(inputs: Mk_Sol_Startup_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The commercial side mentions the Data agent in a channel and gets a number plus how it was computed, without waiting for the one person who writes SQL.`)
};

const id_mk_sol_startup_d3d = /** @type {(inputs: Mk_Sol_Startup_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim komersial menyebut agen Data di channel dan mendapat angka beserta cara menghitungnya, tanpa menunggu satu-satunya orang yang bisa SQL.`)
};

/**
* | output |
* | --- |
* | "The commercial side mentions the Data agent in a channel and gets a number plus how it was computed, without waiting for the one person who writes SQL." |
*
* @param {Mk_Sol_Startup_D3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_d3d = /** @type {((inputs?: Mk_Sol_Startup_D3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_D3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_d3d(inputs)
	return en_mk_sol_startup_d3d(inputs)
});